import type maplibregl from 'maplibre-gl';
import { zoomDisabledState } from './zoomBounds.js';

const PLUS_SVG =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/>' +
  '<line x1="5" y1="12" x2="19" y2="12"/></svg>';
const MINUS_SVG =
  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>';

/** Build segmented +/− zoom buttons that disable at the map's zoom limits. */
export function createZoomControl(parent: HTMLElement, map: maplibregl.Map): void {
  const makeBtn = (label: string, svg: string, onClick: () => void): HTMLButtonElement => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'control-btn';
    btn.setAttribute('aria-label', label);
    btn.innerHTML = svg;
    btn.addEventListener('click', onClick);
    parent.appendChild(btn);
    return btn;
  };

  const zoomIn = makeBtn('Zoom in', PLUS_SVG, () => map.zoomIn());
  const zoomOut = makeBtn('Zoom out', MINUS_SVG, () => map.zoomOut());

  const sync = (): void => {
    const { inDisabled, outDisabled } = zoomDisabledState(
      map.getZoom(),
      map.getMinZoom(),
      map.getMaxZoom(),
    );
    zoomIn.disabled = inDisabled;
    zoomOut.disabled = outDisabled;
  };
  map.on('zoom', sync);
  map.on('zoomend', sync);
  sync();
}
